import image1 from "../../../../image/gonchar1.jpg";
import image2 from "../../../../image/image.webp";
import image3 from "../../../../image/gonchar3.jpg";
export const slides = [
  {
    image: image1,
    title: "Верес навКОЛО",
    subtitle: "Студія живопису",
  },
  {
    image: image2,
    title: "Верес навКОЛО",
    subtitle: "Студія малюнку та живопису (онлайн)",
  },
  {
    image: image3,
    title: "Студія ліплення та гончарства",
    subtitle: "(для дітей та дорослих)",
  },
];
